<template>
  <div class="flex-1 rounded-2xl border border-[#EDE9E3] bg-[#F9F8F6] flex max-[950px]:flex-col max-[950px]:items-center">
    <div
      class="min-w-[16rem] py-12 pl-12 max-[950px]:!p-5 max-[950px]:w-full flex flex-col gap-6"
    >
      <span class="text-[1.25rem] leading-[1.5rem]">
        {{ containerStats.title }}
      </span>
      <img
        :src="containerStats.image"
        :alt="containerStats.imageAlt"
        class="h-[15.25rem] w-[16.875rem] max-[950px]:self-center object-contain"
      />
    </div>
    <div
      class="flex-1 min-w-[16rem] flex flex-col px-12 pt-14 pb-8 max-[950px]:!p-5 gap-5 max-[950px]:gap-6 max-[950px]:w-full"
    >
      <FixedSlider
        hex-color="#3565FC"
        :percentage="containerStats.longevity"
        upper-label="Longevity"
        zero-label="Short-lived"
        hundred-label="Long-lasting"
      />
      <FixedSlider
        hex-color="#06B6D4"
        :percentage="containerStats.condition"
        upper-label="Condition"
        zero-label="Worn-out"
        hundred-label="Pristine"
      />
      <FixedSlider
        hex-color="#14B8A6"
        :percentage="containerStats.aesthetics"
        upper-label="Aesthetics"
        zero-label="Weathered"
        hundred-label="Intact"
      />
      <FixedSlider
        hex-color="#84CC16"
        :percentage="containerStats.cost"
        upper-label="Cost"
        zero-label="Cheap"
        hundred-label="Premium"
      />
    </div>
  </div>
</template>
<script>
import FixedSlider from '../fixed-slider/index.vue'
export default {
  name: 'ContainerStatsCard',
  components: {
    FixedSlider
  },
  props: {
    containerStats: {
      type: Object,
      default: () => ({
        title: '',
        image: '',
        imageAlt: '',
        longevity: 0,
        condition: 0,
        aesthetics: 0,
        cost: 0
      })
    }
  }
}
</script>